import AppImages from "../../../assets/AppImages";
import { StyledScrollContainer } from "../../../components/StyledScrollContainer";

import {
    Chip,
    Avatar,
    Button,
    Typography,
    Card,
    Progress,
} from "@material-tailwind/react";

const TABLE_HEAD = [
    "Vehicle",
    "Assignee",
    "Expenses",
    "Budget",
    "Team",
    "Progress",
    "Due Date",
];

interface InventoryUpdate {
    name: string;
    img: string;
    assignee: any[];
    expenses: number;
    budget: number;
    team: string;
    progress: number;
    due_date: string;
}

const TABLE_ROW: InventoryUpdate[] = [];
//@ts-ignore
const TABLE_ROW_: InventoryUpdate[] = [
    {
        "name": "BMW X4 2024",
        "img": AppImages.bid_1,
        "assignee": [
            {'img': "https://v3.material-tailwind.com/woman-profile-1.jpg",},
        ],
        "expenses": 14000,
        "budget": 23400,
        "team": "Body",
        "progress": 60,
        "due_date": "Yesterday",
    }, {
        "name": "Toyota Camry",
        "img": AppImages.bid_4,
        "assignee": [
            {'img': "https://v3.material-tailwind.com/woman-profile-1.jpg",},
            {'img': "https://v3.material-tailwind.com/man-profile-2.jpg",},
            {'img': "https://v3.material-tailwind.com/woman-profile-2.jpg",},
            {'img': "https://v3.material-tailwind.com/man-profile-3.jpg",},
        ],
        "expenses": 3000,
        "budget":   9400,
        "team":     "Body",
        "progress": 100,
        "due_date": "Today",
    }, {
        "name": "Hyundai Tucson",
        "img": AppImages.bid_5,
        "assignee": [
            {'img': "https://v3.material-tailwind.com/woman-profile-1.jpg",},
            {'img': "https://v3.material-tailwind.com/man-profile-1.jpg",},
            {'img': "https://v3.material-tailwind.com/man-profile-2.jpg",},
            {'img': "https://v3.material-tailwind.com/woman-profile-2.jpg",},
            {'img': "https://v3.material-tailwind.com/man-profile-3.jpg",},
        ],
        "expenses": 8000,
        "budget":   7900,
        "team":     "Body",
        "progress": 30,
        "due_date": "01 Mar 2024",
    }, {
        "name": "Volkswagen Go",
        "img": AppImages.bid_6,
        "assignee": [
            {'img': "https://v3.material-tailwind.com/woman-profile-2.jpg",},
        ],
        "expenses": 5000,
        "budget":   6900,
        "team":     "Body",
        "progress": 100,
        "due_date": "15 Mar 2024",
    }, {
        "name": "Mercedes-Benz C-Class",
        "img": AppImages.bid_7,
        "assignee": [
            {'img': "https://v3.material-tailwind.com/man-profile-2.jpg",},
            {'img': "https://v3.material-tailwind.com/woman-profile-2.jpg",},
        ],
        "expenses": 2000,
        "budget":   3900,
        "team":     "Body",
        "progress": 100,
        "due_date": "27 Mar 2024",
    }, {
        "name": "BMW M4 2023",
        "img": AppImages.bid_2,
        "assignee": [
            {'img': "https://v3.material-tailwind.com/woman-profile-1.jpg",},
            {'img': "https://v3.material-tailwind.com/man-profile-1.jpg",},
            {'img': "https://v3.material-tailwind.com/man-profile-2.jpg",},
            {'img': "https://v3.material-tailwind.com/woman-profile-2.jpg",},
            {'img': "https://v3.material-tailwind.com/man-profile-3.jpg",},
        ],
        "expenses": 5000,
        "budget":   8900,
        "team":     "Body",
        "progress": 100,
        "due_date": "30 Mar 2024",
    }
];

export function DashboardInventoryUpdate() {
    //const dispatch = useDispatch();
    //const { deliveries, loading } = useSelector((state: any) => state.parts);

    /*
    useEffect(() => {
        //dispatch(listPartsDeliveryRequest({vehicle_fields: 'id,status,display_status,is_listed,ymmt,thumbnail,make,model,vin,inspection_score,inspection_results,parts,tasks,labors,delivery_company,delivery_order,delivery_pickup_date,delivery_est_date,delivery_date,'}));
    }, [dispatch]);
     */

    const get_due_color = (el:any) => {
        if (el.due_date == 'Today') {
            return "success"
        } else if (el.due_date == 'Yesterday') {
            return "error"
        } else {
            return "primary"
        }
    };

    return (
        <Card>
            <Card.Header className="w-full m-0 items-start rounded-none flex flex-wrap gap-4 justify-between p-4">
                <div>
                    <Typography
                        type="lead"
                        color="default"
                        className="font-semibold mb-1"
                    >
                        Inventory Updates
                    </Typography>
                    <Typography type="small" className="text-foreground block">
                        <b>30 tasks done</b> this month
                    </Typography>
                </div>
                <div className="flex gap-3 items-center sm:w-auto w-full">
                    <Button
                        variant="outline"
                        color="secondary"
                        className="flex items-center shrink-0 gap-2 sm:w-auto w-full"
                    >
                        See All
                    </Button>
                </div>
            </Card.Header>
            <StyledScrollContainer className="max-h-[400px]">
                <Card.Body className="p-0 rounded-none">
                    <table className="w-full min-w-max table-auto text-left">
                        <thead>
                            <tr>
                                {
                                    TABLE_HEAD.map((head) => (
                                        <th key={head} className={`border-b border-surface p-4 ${head == 'Assignee' ? "text-center" : ""}`}>
                                            <Typography
                                                type="small"
                                                color="default"
                                                className="block font-medium"
                                            >
                                                {head}
                                            </Typography>
                                        </th>
                                    ))
                                }
                            </tr>
                        </thead>
                        <tbody>
                            {TABLE_ROW.map((el, index) => (
                                <tr key={index} className="group">
                                    <td className="p-4 border-b border-surface group-last:border-none">
                                        <div className="flex items-center gap-3">
                                            <Avatar src={el.img} alt={el.name} shape="rounded" />
                                            <div className="space-y-1">
                                                <Typography
                                                    type="small"
                                                    color="default"
                                                    className="font-semibold block"
                                                >
                                                    {el.name}
                                                </Typography>
                                            </div>
                                        </div>
                                    </td>
                                    <td className="p-4 border-b border-surface">
                                        <div className="flex items-center justify-center -space-x-3">
                                            {el.assignee.map((a, key) => (
                                                <Avatar
                                                    key={key}
                                                    src={a.img}
                                                    size="sm"
                                                    alt={`avatar-${key}`}
                                                    className="border-2 border-secondary hover:z-10 focus:z-10"
                                                />
                                            ))}
                                        </div>
                                    </td>
                                    <td className="p-4 border-b border-surface group-last:border-none">
                                        <Typography type="small" className="block text-foreground">
                                            ${el.expenses.toLocaleString('en-US')}
                                        </Typography>
                                    </td>
                                    <td className="p-4 border-b border-surface group-last:border-none">
                                        <Typography type="small" className="block text-foreground">
                                            ${el.budget.toLocaleString('en-US')}
                                        </Typography>
                                    </td>
                                    <td className="p-4 border-b border-surface group-last:border-none">
                                        <Chip size="sm" isPill={false} variant="outline" className="w-max border-[#E2E8F0]">
                                            <Chip.Label>{el.team}</Chip.Label>
                                        </Chip>
                                    </td>
                                    <td className="p-4 border-b border-surface group-last:border-none">
                                        <Typography type="small" className="block text-foreground">
                                            {el.progress}
                                        </Typography>
                                        <Progress size="sm" color={el.progress > 80 ? "success" : el.progress > 50 ? "warning" : "primary"} value={el.progress}>
                                            <Progress.Bar />
                                        </Progress>
                                    </td>
                                    <td className="p-4 border-b border-surface group-last:border-none">
                                        <Typography type="small" color={get_due_color(el)} className="block">
                                            {el.due_date}
                                        </Typography>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    {TABLE_ROW.length == 0 &&
                        <div className="flex flex-col my-20 gap-5 justify-center items-center h-full">
                            <div className="flex bg-secondary items-center p-4 rounded-full">
                                <AppImages.IconPurchaseInventory className="w-6 h-6" />
                            </div>
                            <Typography className="text-primary font-semibold text-2xl">
                                No inventory updates
                            </Typography>
                        </div>
                    }
                </Card.Body>
            </StyledScrollContainer>
        </Card>
    );
}
